// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file plugnmeet_recording.proto (package plugnmeet, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { CloudRecordingVariants, RecordingTasks } from "./plugnmeet_recorder_pb";
import { file_plugnmeet_recorder } from "./plugnmeet_recorder_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plugnmeet_recording.proto.
 */
export const file_plugnmeet_recording: GenFile = /*@__PURE__*/
  fileDesc("ChlwbHVnbm1lZXRfcmVjb3JkaW5nLnByb3RvEglwbHVnbm1lZXQi9gIKDFJlY29yZGluZ1JlcRInCgR0YXNrGAEgASgOMhkucGx1Z25tZWV0LlJlY29yZGluZ1Rhc2tzEg8KB3Jvb21faWQYAiABKAkSGQoNcm9vbV90YWJsZV9pZBgDIAEoA0ICMAESCwoDc2lkGAQgASgJEhUKCHJ0bXBfdXJsGAUgASgJSACIAQESGgoNY3VzdG9tX2Rlc2lnbhgGIAEoCUgBiAEBEkEKEXJlY29yZGluZ192YXJpYW50GAcgASgOMiEucGx1Z25tZWV0LkNsb3VkUmVjb3JkaW5nVmFyaWFudHNIAogBARJAChRyZWNvcmRlcl9ib3Rfb3B0aW9ucxgIIAEoCzIdLnBsdWdubWVldC5SZWNvcmRlckJvdE9wdGlvbnNIA4gBAUILCglfcnRtcF91cmxCEAoOX2N1c3RvbV9kZXNpZ25CFAoSX3JlY29yZGluZ192YXJpYW50QhcKFV9yZWNvcmRlcl9ib3Rfb3B0aW9ucyKJAgoRUmVjb3JkaW5nSW5mb0ZpbGUSGQoNcm9vbV90YWJsZV9pZBgBIAEoA0ICMAESDwoHcm9vbV9pZBgCIAEoCRISCgpyb29tX3RpdGxlGAMgASgJEhAKCHJvb21fc2lkGAQgASgJEh4KEnJvb21fY3JlYXRpb25fdGltZRgFIAEoA0ICMAESFgoKcm9vbV9lbmRlZBgGIAEoA0ICMAESFAoMcmVjb3JkaW5nX2lkGAcgASgJEhMKC3JlY29yZGVyX2lkGAggASgJEhEKCWZpbGVfcGF0aBgJIAEoCRIRCglmaWxlX3NpemUYCiABKAISGQoNY3JlYXRpb25fdGltZRgLIAEoA0ICMAEiLwoRUmVjb3JkaW5nU3VidGl0bGUSDQoFbGFiZWwYASABKAkSCwoDdXJsGAIgASgJIt4CChFSZWNvcmRpbmdNZXRhZGF0YRISCgV0aXRsZRgBIAEoCUgAiAEBEhgKC2Rlc2NyaXB0aW9uGAIgASgJSAGIAQESPgoJc3VidGl0bGVzGAMgAygLMisucGx1Z25tZWV0LlJlY29yZGluZ01ldGFkYXRhLlN1YnRpdGxlc0VudHJ5Ej8KCmV4dHJhX2RhdGEYBCADKAsyKy5wbHVnbm1lZXQuUmVjb3JkaW5nTWV0YWRhdGEuRXh0cmFEYXRhRW50cnkaTgoOU3VidGl0bGVzRW50cnkSCwoDa2V5GAEgASgJEisKBXZhbHVlGAIgASgLMhwucGx1Z25tZWV0LlJlY29yZGluZ1N1YnRpdGxlOgI4ARowCg5FeHRyYURhdGFFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBQggKBl90aXRsZUIOCgxfZGVzY3JpcHRpb24ihAEKElJlY29yZGVyQm90T3B0aW9ucxIkChxlbmFibGVfYXV0b19jbG9zZV9jaGF0X3BhbmVsGAEgASgIEigKG2R1cmF0aW9uX2FmdGVyX2xhc3RfbWVzc2FnZRgCIAEoDUgAiAEBQh4KHF9kdXJhdGlvbl9hZnRlcl9sYXN0X21lc3NhZ2VCoAEKDWNvbS5wbHVnbm1lZXRCF1BsdWdubWVldFJlY29yZGluZ1Byb3RvUAFaMmdpdGh1Yi5jb20vbXluYXBhcnJvdC9wbHVnbm1lZXQtcHJvdG9jb2wvcGx1Z25tZWV0ogIDUFhYqgIJUGx1Z25tZWV0ygIJUGx1Z25tZWV04gIVUGx1Z25tZWV0XEdQQk1ldGFkYXRh6gIJUGx1Z25tZWV0YgZwcm90bzM", [file_plugnmeet_recorder]);

/**
 * @generated from message plugnmeet.RecordingReq
 */
export type RecordingReq = Message<"plugnmeet.RecordingReq"> & {
  /**
   * @generated from field: plugnmeet.RecordingTasks task = 1;
   */
  task: RecordingTasks;

  /**
   * @generated from field: string room_id = 2;
   */
  roomId: string;

  /**
   * @generated from field: int64 room_table_id = 3 [jstype = JS_STRING];
   */
  roomTableId: string;

  /**
   * @generated from field: string sid = 4;
   */
  sid: string;

  /**
   * @generated from field: optional string rtmp_url = 5;
   */
  rtmpUrl?: string | undefined;

  /**
   * @generated from field: optional string custom_design = 6;
   */
  customDesign?: string | undefined;

  /**
   * @generated from field: optional plugnmeet.CloudRecordingVariants recording_variant = 7;
   */
  recordingVariant?: CloudRecordingVariants | undefined;

  /**
   * @generated from field: optional plugnmeet.RecorderBotOptions recorder_bot_options = 8;
   */
  recorderBotOptions?: RecorderBotOptions | undefined;
};

/**
 * Describes the message plugnmeet.RecordingReq.
 * Use `create(RecordingReqSchema)` to create a new message.
 */
export const RecordingReqSchema: GenMessage<RecordingReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_recording, 0);

/**
 * @generated from message plugnmeet.RecordingInfoFile
 */
export type RecordingInfoFile = Message<"plugnmeet.RecordingInfoFile"> & {
  /**
   * @generated from field: int64 room_table_id = 1 [jstype = JS_STRING];
   */
  roomTableId: string;

  /**
   * @generated from field: string room_id = 2;
   */
  roomId: string;

  /**
   * @generated from field: string room_title = 3;
   */
  roomTitle: string;

  /**
   * @generated from field: string room_sid = 4;
   */
  roomSid: string;

  /**
   * @generated from field: int64 room_creation_time = 5 [jstype = JS_STRING];
   */
  roomCreationTime: string;

  /**
   * @generated from field: int64 room_ended = 6 [jstype = JS_STRING];
   */
  roomEnded: string;

  /**
   * @generated from field: string recording_id = 7;
   */
  recordingId: string;

  /**
   * @generated from field: string recorder_id = 8;
   */
  recorderId: string;

  /**
   * @generated from field: string file_path = 9;
   */
  filePath: string;

  /**
   * @generated from field: float file_size = 10;
   */
  fileSize: number;

  /**
   * @generated from field: int64 creation_time = 11 [jstype = JS_STRING];
   */
  creationTime: string;
};

/**
 * Describes the message plugnmeet.RecordingInfoFile.
 * Use `create(RecordingInfoFileSchema)` to create a new message.
 */
export const RecordingInfoFileSchema: GenMessage<RecordingInfoFile> = /*@__PURE__*/
  messageDesc(file_plugnmeet_recording, 1);

/**
 * @generated from message plugnmeet.RecordingSubtitle
 */
export type RecordingSubtitle = Message<"plugnmeet.RecordingSubtitle"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;
};

/**
 * Describes the message plugnmeet.RecordingSubtitle.
 * Use `create(RecordingSubtitleSchema)` to create a new message.
 */
export const RecordingSubtitleSchema: GenMessage<RecordingSubtitle> = /*@__PURE__*/
  messageDesc(file_plugnmeet_recording, 2);

/**
 * @generated from message plugnmeet.RecordingMetadata
 */
export type RecordingMetadata = Message<"plugnmeet.RecordingMetadata"> & {
  /**
   * @generated from field: optional string title = 1;
   */
  title?: string | undefined;

  /**
   * @generated from field: optional string description = 2;
   */
  description?: string | undefined;

  /**
   * e.g. map<language, RecordingSubtitle>
   *
   * @generated from field: map<string, plugnmeet.RecordingSubtitle> subtitles = 3;
   */
  subtitles: { [key: string]: RecordingSubtitle };

  /**
   * @generated from field: map<string, string> extra_data = 4;
   */
  extraData: { [key: string]: string };
};

/**
 * Describes the message plugnmeet.RecordingMetadata.
 * Use `create(RecordingMetadataSchema)` to create a new message.
 */
export const RecordingMetadataSchema: GenMessage<RecordingMetadata> = /*@__PURE__*/
  messageDesc(file_plugnmeet_recording, 3);

/**
 * @generated from message plugnmeet.RecorderBotOptions
 */
export type RecorderBotOptions = Message<"plugnmeet.RecorderBotOptions"> & {
  /**
   * if true, chat panel will be closed automatically after a certain duration
   *
   * @generated from field: bool enable_auto_close_chat_panel = 1;
   */
  enableAutoCloseChatPanel: boolean;

  /**
   * duration in seconds. After this duration, the chat panel will be closed.
   *
   * @generated from field: optional uint32 duration_after_last_message = 2;
   */
  durationAfterLastMessage?: number | undefined;
};

/**
 * Describes the message plugnmeet.RecorderBotOptions.
 * Use `create(RecorderBotOptionsSchema)` to create a new message.
 */
export const RecorderBotOptionsSchema: GenMessage<RecorderBotOptions> = /*@__PURE__*/
  messageDesc(file_plugnmeet_recording, 4);

